import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody, TablePagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getUnActiveRequests } from "../../../reduxStore/entities/userCars";
import UnActiveCarRequestTableRow from "../TableRows/UnActiveCarRequestTableRow";
import UnActiveRequestsTableHead from "../TableHeads/UnActiveRequestsTableHead";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";

const UnActiveRequestsTable = ({
    id
}) => {
    const DEFAULT_ROWS_PER_PAGE = 15;

    const [isTableShown, setIsTableShown] = useState(true);

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);


    const fetchedUnActiveCarRequests = useSelector((state) => state.userCars.unActiveRequests);
    const count = useSelector((state) => state.userCars.unActiveCount);

    const filterDto = {
        id: id,
        limit: rowsPerPage,
        offset: page * rowsPerPage,
    };

    const [filter, setFilter] = useState(filterDto);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedUnActiveCarRequests]);

    useEffect(() => {
        setFilter(filterDto);
    }, [page, rowsPerPage]);

    useEffect(() => {
        dispatch(getUnActiveRequests(filter));
    }, [filter]);


    if (!loaded) {
        return null;
    };


    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Ostali zahtevi"}
                count={count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <UnActiveRequestsTableHead />

                            <TableBody>

                                {fetchedUnActiveCarRequests.map((row, index) => (
                                    <UnActiveCarRequestTableRow
                                        key={index}
                                        carRequest={row}
                                    />
                                ))}

                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[15, 25, 50]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(event, newPage) => {
                                handleChangePage(event, newPage, setPage)
                            }}
                            onRowsPerPageChange={(event) => {
                                handleChangeRowsPerPage(
                                    event,
                                    setRowsPerPage,
                                    setPage
                                )
                            }}
                        />

                    </div>
                </div>
            )}

        </div>
    );
};


export default UnActiveRequestsTable;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    }
};